// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"styles_filterWrapper__2wBuq","filterBox":"styles_filterBox__2cH3y","filterInput":"styles_filterInput__3H_8-"};